/* Glambe mobile pass 4: search prices follow the converter, Tamara follows the pack, pack dots, floating AI button, size + real review stars. Loaded (defer) from snippets/gb-menu.liquid. */
(function(){
  if(window.__gbm4)return; window.__gbm4=1;
  var D=document,root=D.documentElement,AR=(root.lang||'').slice(0,2)==='ar';
  function q(s,r){return (r||D).querySelector(s)}
  function qa(s,r){return [].slice.call((r||D).querySelectorAll(s))}
  function throttle(fn,ms){var t=0;return function(){if(t)return;t=setTimeout(function(){t=0;fn()},ms)}}
  var data={};try{var de=D.getElementById('gbm4-data');if(de)data=JSON.parse(de.textContent)||{}}catch(e){}

  /* 3. Prices that arrive after load (live search results, recommended products): Bucks does not convert them, so ask it to (once per fresh, unconverted price) */
  function searchMoney(){
    if(!(window.bucksCC&&window.bucksCC.reConvert))return;
    var els=qa('.money:not([bucks-init]):not(.buckscc-converted):not([data-gbm4t])'); if(!els.length)return;
    els.forEach(function(e){e.setAttribute('data-gbm4t','1')});
    try{window.bucksCC.reConvert()}catch(e){}
  }

  /* 4. Tamara: selected pack total, in the visitor's currency when Tamara supports it (AED otherwise) */
  var TAM={AED:'AE',SAR:'SA',KWD:'KW',BHD:'BH',QAR:'QA',OMR:'OM'},DEC3={KWD:1,BHD:1,OMR:1},tamKey='';
  function ref(){
    var e=q('.money[bucks-init][bucks-current]'); if(!e)return null;
    var init=parseFloat(e.getAttribute('bucks-init')),m=String(e.getAttribute('bucks-current')||e.textContent).match(/(\d[\d,]*(?:\.\d+)?)/);
    if(!m||!(init>0))return null;
    return {r:parseFloat(m[1].replace(/,/g,''))/init,code:(e.getAttribute('bucks-currency')||'').toUpperCase()};
  }
  function aedNow(){
    var jd=q('script[data-gbp]'); if(!jd)return null; var base; try{base=JSON.parse(jd.textContent)}catch(e){return null}
    if(!base||!base.variants||!base.variants.length)return null;
    var idEl=q('[data-id]'),id=idEl?+idEl.value:0,v=base.variants[0];
    base.variants.forEach(function(x){if(x.id===id)v=x});
    var pk=q('.gbk__pack.on'),qty=1,pct=0;
    if(pk){qty=+pk.getAttribute('data-qty')||1;pct=+pk.getAttribute('data-pct')||0}else{var qe=q('[data-quantity]');qty=+(qe&&qe.value)||1}
    return Math.floor(v.price*qty*(100-pct)/100)/100;
  }
  function tamara(){
    var w=q('tamara-widget'); if(!w||!window.TamaraWidgetV2||!window.tamaraWidgetConfig)return;
    var a=aedNow(); if(a==null||!(a>0))return;
    var R=ref(),code=(R&&R.code)||'AED',country='AE',amt=a;
    if(R&&TAM[code]){country=TAM[code];amt=a*R.r}
    var out=(DEC3[code]&&country!=='AE')?amt.toFixed(3):amt.toFixed(2),key=country+'|'+out;
    if(key===tamKey&&w.getAttribute('amount')===out)return; tamKey=key;
    window.tamaraWidgetConfig.country=country; w.setAttribute('amount',out);
    try{window.TamaraWidgetV2.refresh()}catch(e){}
  }

  /* 6. Pack selector on small phones: swipe row with a peek of the next card, dots, edge fade */
  function packs(){
    var wrap=q('.gbk__packs'); if(!wrap||wrap.__gbm4)return; wrap.__gbm4=1;
    var ps=qa('.gbk__pack',wrap); if(ps.length<2)return;
    var dots=D.createElement('div'); dots.className='gbm4-dots'; dots.setAttribute('aria-hidden','true');
    ps.forEach(function(){dots.appendChild(D.createElement('i'))});
    wrap.parentNode.insertBefore(dots,wrap.nextSibling);
    function over(){return wrap.scrollWidth>wrap.clientWidth+2}
    function upd(){
      if(!over()){dots.style.display='none';wrap.classList.remove('gbm4-more');return}
      dots.style.display='';
      var mid=wrap.scrollLeft+wrap.clientWidth/2,best=0,bd=1e9;
      ps.forEach(function(p,i){var d=Math.abs(p.offsetLeft+p.offsetWidth/2-mid);if(d<bd){bd=d;best=i}});
      if(wrap.scrollLeft<=2)best=0;else if(wrap.scrollLeft+wrap.clientWidth>=wrap.scrollWidth-2)best=ps.length-1;
      [].forEach.call(dots.children,function(d,i){d.className=i===best?'on':''});
      wrap.classList.toggle('gbm4-more',wrap.scrollLeft+wrap.clientWidth<wrap.scrollWidth-6);
    }
    function center(smooth){
      var on=q('.gbk__pack.on',wrap); if(!on||!over())return;
      var x=Math.max(0,on.offsetLeft-(wrap.clientWidth-on.offsetWidth)/2);
      if(wrap.scrollTo)wrap.scrollTo({left:x,behavior:smooth?'smooth':'auto'});else wrap.scrollLeft=x;
    }
    wrap.addEventListener('scroll',throttle(upd,50),{passive:true});
    wrap.addEventListener('change',function(){setTimeout(function(){center(true);upd()},60)});
    addEventListener('resize',throttle(function(){upd()},150));
    center(false); upd(); setTimeout(function(){center(false);upd()},600);
  }

  /* 7. AI button on product pages: only after the buy box has been scrolled past */
  function fab(){
    var k=q('[data-gbk]'); root.classList.toggle('gbm4-pdp',!!k); if(!k)return;
    function upd(){var r=k.getBoundingClientRect();D.body.classList.toggle('gbm4-past',r.bottom<0)}
    addEventListener('scroll',throttle(upd,80),{passive:true}); addEventListener('resize',throttle(upd,150)); upd();
  }

  /* 5 + 9. Real review stars under the title, size next to the price, rating strip on the homepage (only with real data) */
  function stars(a){var s='';for(var i=1;i<=5;i++)s+='<i class="'+(i<=Math.round(a)?'on':'')+'">&#9733;</i>';return '<span class="gbm4-st" aria-hidden="true">'+s+'</span>'}
  function extras(){
    var t=q('.gbp__title');
    if(t&&data.pn>0&&!q('.gbm4-rate')){
      var r=D.createElement('a'); r.className='gbm4-rate'; r.href='#gbpf';
      r.innerHTML=stars(data.pavg)+'<span>'+Number(data.pavg).toFixed(1)+' · '+data.pn+' '+(AR?'تقييم':('review'+(data.pn>1?'s':'')))+'</span>';
      t.insertAdjacentElement('afterend',r);
    }
    var pr=q('.gbp__price');
    if(pr&&data.size&&!q('.gbm4-size')){var s=D.createElement('span'); s.className='gbm4-size'; s.textContent=data.size; pr.appendChild(s)}
    if(data.page==='index'&&data.n>0&&!q('.gbm4-strip')){
      var first=q('main .shopify-section')||q('.shopify-section');
      if(first){var d=D.createElement('div'); d.className='gbm4-strip'; d.innerHTML=Number(data.avg).toFixed(1)+' <b aria-hidden="true">&#9733;</b> '+(AR?'من ':'from ')+data.n+(AR?' عميل':' customers'); first.insertAdjacentElement('afterend',d)}
    }
  }

  var tm=0;
  function run(){tm=0;searchMoney();tamara();packs();extras()}
  function sched(){if(!tm)tm=setTimeout(run,150)}
  function start(){
    fab(); run();
    new MutationObserver(sched).observe(D.body,{childList:true,subtree:true});
    ['change','click'].forEach(function(ev){D.addEventListener(ev,function(e){if(ev==='click'&&!(e.target.closest&&e.target.closest('[data-minus],[data-plus],.gbk__pack,[data-gbk-up]')))return;setTimeout(tamara,80)},true)});
    new MutationObserver(throttle(tamara,200)).observe(D.body,{subtree:true,attributes:true,attributeFilter:['bucks-currency','bucks-current']});
    [600,1800,4000].forEach(function(ms){setTimeout(function(){tamara();packs();extras()},ms)});
  }
  if(D.readyState==='loading')D.addEventListener('DOMContentLoaded',start);else start();
})();
